export function obterListaTipoRestricao() {
  return (
    [
      { label: '0 - Não há', value: 'NAOHA' },
      { label: '1 - Alienação Fiduciária', value: 'ALIENACAO' },
      { label: '2 - Arrendamento Mercantil', value: 'ARRENDAMENTO' },
      { label: '3 - Reserva de Domínio', value: 'RESERVA' },
      { label: '4 - Penhor de Veículos', value: 'PENHOR' },
      { label: '9 - Outras', value: 'OUTRAS' },
    ]
  );
}
